import { cva } from 'class-variance-authority'

// Shared with SidebarMenuSkeleton so the placeholder occupies the same box as the row.
export const sidebarMenuRowPadding = {
  default: 'p-30 max-md:p-40',
  compact: 'px-30 py-20 max-md:px-40 max-md:py-30',
} as const
export const sidebarMenuRowLabelHeight = 'var(--leading-30)'

// The two gradient layers cross-fade on opacity: gradients themselves cannot interpolate.
// `hover:no-underline` and `active:scale-100` override Button's text variant on full-width rows.
export const sidebarMenuButtonVariants = cva(
  `
    relative isolate flex h-auto w-full items-center justify-start gap-40 rounded-20 border-none text-20 leading-30
    font-400 tracking-20 text-content-base-main no-underline
    before:absolute before:inset-0 before:-z-10 before:rounded-[inherit] before:bg-gradient-brand-tint before:opacity-0
    before:transition-opacity before:motion-press
    after:absolute after:inset-0 after:-z-10 after:rounded-[inherit] after:bg-gradient-brand-tint-deep after:opacity-0
    after:transition-opacity after:motion-press
    hover:bg-surface-base-secondary-hover hover:no-underline
    active:scale-100
    active:after:opacity-100
    data-[active=true]:before:opacity-100
    data-[status=active]:before:opacity-100
    [&_svg]:shrink-0
    [&_svg:not([class*='size-'])]:size-4
  `,
  {
    variants: {
      // `compact` is the footer shape (legal links, sign out): same row, tighter vertical padding.
      density: sidebarMenuRowPadding,
    },
    defaultVariants: { density: 'default' },
  },
)
